import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {ClockService} from '@app/app/shared/services/clock.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'park-clock-view',
  templateUrl: './clock.component.html'
})

export class ClockComponent implements OnInit, OnDestroy {
  private _clockSubscription: Subscription;
  time: string;
  @Input() timezone: string;
  @Input() meta: any;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  private elapsedTime = 0;

  constructor(private clockService: ClockService) {
  }

  ngOnInit() {
    this._clockSubscription = this.clockService.getClock().subscribe((time) => {
        this.newTime();
    });
  }

  public newTime() {
    this.elapsedTime += 1000;

    if (this.meta && this.meta.hasOwnProperty('system time')) {
      const m = moment.tz(this.meta['system time'] + this.elapsedTime, 'UTC');
      this.time = m.format('MMM Do YYYY, HH:mm:ss');
    } else {
      const m = moment.tz(new Date(), this.timezone);
      this.time = m.format('MMM Do YYYY, HH:mm:ss');
    }
  }

  ngOnDestroy(): void {
    if (this._clockSubscription) {
      this._clockSubscription.unsubscribe();
    }
  }

  public setEditMode() {
    this.getSearchStatusChange.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/clock/clock.component.ts